//# sourceMappingURL=posthog.mjs.map
/// <reference types="./posthog.d.mts" />
import * as $json from "../gleam_json/gleam/json.mjs";
import * as $option from "../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../gleam_stdlib/gleam/option.mjs";
import * as $result from "../gleam_stdlib/gleam/result.mjs";
import * as $string from "../gleam_stdlib/gleam/string.mjs";
import * as $redraw from "../redraw/redraw.mjs";
import { Error, CustomType as $CustomType } from "./gleam.mjs";
import {
  useIdentify as use_identify,
  reset,
  capture,
  newException as exception,
  captureException as do_capture_exception,
  Provider as provider,
} from "./posthog.ffi.tsx";

export { capture, exception, provider, reset, use_identify };

export class Options extends $CustomType {
  constructor(defaults, api_host, capture_exceptions) {
    super();
    this.defaults = defaults;
    this.api_host = api_host;
    this.capture_exceptions = capture_exceptions;
  }
}
export const Options$Options = (defaults, api_host, capture_exceptions) =>
  new Options(defaults, api_host, capture_exceptions);
export const Options$isOptions = (value) => value instanceof Options;
export const Options$Options$defaults = (value) => value.defaults;
export const Options$Options$0 = (value) => value.defaults;
export const Options$Options$api_host = (value) => value.api_host;
export const Options$Options$1 = (value) => value.api_host;
export const Options$Options$capture_exceptions = (value) =>
  value.capture_exceptions;
export const Options$Options$2 = (value) => value.capture_exceptions;

export function options() {
  return new Options(new None(), new None(), new None());
}

export function defaults(options, def) {
  let defaults$1 = new Some(def);
  return new Options(defaults$1, options.api_host, options.capture_exceptions);
}

export function api_host(options, host) {
  let api_host$1 = new Some(host);
  return new Options(options.defaults, api_host$1, options.capture_exceptions);
}

/**
 * https://posthog.com/docs/error-tracking/installation/web
 */
export function capture_exceptions(options, enabled) {
  let capture_exceptions$1 = new Some(enabled);
  return new Options(options.defaults, options.api_host, capture_exceptions$1);
}

/**
 * Sends `exception`, with `error` as its message. Returns an error if PostHog
 * is not initialized, or captured nothing.
 * https://posthog.com/docs/error-tracking/capture
 */
export function capture_exception(exception, error) {
  return do_capture_exception(exception, $string.inspect(error));
}

/**
 * PostHog automatically captures errors on the frontend.
 * However if we want to capture custom and arbitrary errors,
 * such as with the WebSocket, we need to send those here.
 */
export function capture_error(error, exception) {
  return $result.try_recover(
    error,
    (content) => {
      let $ = capture_exception(exception, content);
      
      return new Error(content);
    },
  );
}
